import { useSelector } from "react-redux";
import { wrapper } from "../../redux";
import { addBreadcrumb } from "../../redux/action-creaters/breadcrumbs";
import Redis from "/lib/redis";
import pagesWrapper from "../../utils/pagesWrapper";
import LayoutWrapper from "../../components/layouts/layoutWrapper";
import LeftSide from "../../components/layouts/leftSide";
import InfoMenu from "../../components/pages/faq/menu";

export default function InfoPage({ scripts, host, isBaltex }) {
  const { content } = useSelector((state) => state.meta);
  return (
    <LayoutWrapper scripts={scripts} host={host}>
      <LeftSide
        isBaltex={isBaltex}
        side={<InfoMenu isBaltex={isBaltex}></InfoMenu>}
        title="Для покупателей"
      >
        <div className={"text"}>
          <div dangerouslySetInnerHTML={{ __html: content }} />
        </div>
      </LeftSide>
    </LayoutWrapper>
  );
}

export const getServerSideProps = wrapper.getServerSideProps(function (store) {
  return async ({ req, query }) => {
    store.dispatch(addBreadcrumb({ link: "/info/", name: "Для покупателей" }));

    return pagesWrapper(
      {},
      store,
      Redis,
      {
        req,
        query,
      },
      "/info/",
    );
  };
});
